import { supabase } from '../supabase';

const ENCOUNTERS_TABLE = 'encounters';

export async function listEncounters(userId) {
  const { data, error } = await supabase
    .from(ENCOUNTERS_TABLE)
    .select('id, name, updated_at')
    .eq('user_id', userId)
    .order('updated_at', { ascending: false });

  if (error) throw error;
  return data || [];
}

export async function loadEncounter(userId, encounterId) {
  const { data, error } = await supabase
    .from(ENCOUNTERS_TABLE)
    .select('id, name, payload, updated_at')
    .eq('user_id', userId)
    .eq('id', encounterId)
    .single();

  if (error) throw error;
  return data;
}

export async function saveEncounter({ userId, encounterId, name, payload }) {
  if (encounterId) {
    const { data, error } = await supabase
      .from(ENCOUNTERS_TABLE)
      .update({ name, payload, updated_at: new Date().toISOString() })
      .eq('user_id', userId)
      .eq('id', encounterId)
      .select('id, name, updated_at')
      .single();

    if (error) throw error;
    return data;
  }

  const { data, error } = await supabase
    .from(ENCOUNTERS_TABLE)
    .insert({ user_id: userId, name, payload })
    .select('id, name, updated_at')
    .single();

  if (error) throw error;
  return data;
}
